import * as Yup from 'yup';
import VALUE_TYPES from '../../../configs/ValueTypeConstants';

export const InitialStudentState = {
    code: null,
    first_name: null,
    last_name: null,
    status: true,
    division: null,
    address1: null,
    father_name: null,
    father_mobile: "971",
    father_email: null,
    mother_name: null,
    mother_mobile: "971",
    mother_email: null,
    remarks: null,
    class_id: null,
    academic_year_id: null,
    school_id: null,
    photo_link: null,
    student_transport_details: [],
    credit_ledger_id: null,
};

export const StudentSchema = Yup.object().shape({
    code: Yup.string().required(),
    first_name: Yup.string().required(),
    last_name: Yup.string().nullable(),
    status: Yup.boolean().required(),
    class_id: Yup.string().required(),
    division: Yup.string().nullable(),
    address1: Yup.string().nullable(),
    father_name: Yup.string().nullable(),
    father_mobile: Yup.string().required().min(4),
    father_email: Yup.string().required().email(),
    mother_name: Yup.string().nullable(),
    mother_mobile: Yup.string().nullable(),
    mother_email: Yup.string().nullable().email(),
    remarks: Yup.string().nullable(),
    academic_year_id: Yup.string().nullable(),
    school_id: Yup.number().required(),
    photo_link: Yup.string().nullable(),
    credit_ledger_id: Yup.number().required()
});

export const FormFields = [
    { name: "code", title: "Student Code", required: true, type: VALUE_TYPES.TEXT },
    { name: "first_name", title: "First Name", required: true, type: VALUE_TYPES.TEXT },
    { name: "last_name", title: "Last Name", required: false, type: VALUE_TYPES.TEXT },
    { name: "school_id", title: "School", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "class_id", title: "Class", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "division", title: "Division", required: false, type: VALUE_TYPES.TEXT },
    { name: "father_name", title: "Father Name", required: false, type: VALUE_TYPES.TEXT },
    { name: "father_mobile", title: "Father Mobile", required: true, type: VALUE_TYPES.TEXT },
    { name: "father_email", title: "Father Email", required: true, type: VALUE_TYPES.TEXT },
    { name: "mother_name", title: "Mother Name", required: false, type: VALUE_TYPES.TEXT },
    { name: "mother_mobile", title: "Mother Mobile", required: false, type: VALUE_TYPES.TEXT },
    { name: "mother_email", title: "Mother Email", required: false, type: VALUE_TYPES.TEXT },
    { name: "remarks", title: "Remarks", required: false, type: VALUE_TYPES.TEXT },
    { name: "academic_year_id", title: "Academic Year", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "academic_year", itemValue: "id" },
    { name: "credit_ledger_id", title: "Credit Ledger", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "code_name", itemValue: "id", disabled: true },
    { name: "status", title: "Status", required: true, type: VALUE_TYPES.SWITCH, options: [{ title: "Active", id: true }, { title: "In-Active", id: false }] },
];

export const AddressFormFields = [
    { name: "address1", title: "Address 1", required: false, type: VALUE_TYPES.TEXTAREA }
]


const filterState = {
    schools: null,
    status: null,
};
const filterSchema = Yup.object().shape({
    schools: Yup.array().nullable(),
    status: Yup.string().nullable(),
});

const filterFormFields: any[] = [
    { name: "schools", title: "Schools", required: false, type: VALUE_TYPES.MULTISELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "status", title: "Status", required: false, type: VALUE_TYPES.SELECT, options: [{ name: "Active" }, { name: "In-Active" }], apiRequired: true, displayKey: "name", itemValue: "name" },
];

export const filter = {
    state: filterState,
    schema: filterSchema,
    formFields: filterFormFields
}

